


























import Vue from 'vue'
import { required, email } from 'vuelidate/lib/validators'
import ForgotPasswordInfo from '@/components/Auth/ForgotPasswordInfo.vue'
import SubmitButton from '@/components/buttons/SubmitButton.vue'
import AuthService from '@/services/authentication.service'
import { errorMessages } from '@/utils/helpers'

export default Vue.extend({
  name: 'ForgotPassword',
  components: { SubmitButton, ForgotPasswordInfo },
  data() {
    return {
      email: '',
      showForm: true,
    }
  },
  validations: {
    email: {
      required,
      email,
    },
  },
  computed: {
    emailErrors() {
      const errors: string[] = []

      if (!this.$v.email.$dirty) {
        return errors
      }

      !this.$v.email.email && errors.push(this.$t('validation.emailField', { field: 'Email' }) as string)
      !this.$v.email.required && errors.push(this.$t('validation.requiredField', { field: 'Email' }) as string)

      return errors
    },
  },
  methods: {
    async submit() {
      this.$v.$touch()

      if (this.$v.$anyError) {
        return
      }

      const loader = this.$loading.show()
      try {
        await AuthService.requestPasswordReset(this.email)
        this.showForm = false
      } catch (err) {
        if (err.response?.data) {
          this.$toast.error(errorMessages(err.response.data.message))
          return
        }
        this.$toast.error(this.$t('somethingWentWrong') as string)
      } finally {
        loader.hide()
      }
    },
  },
})
